import { checkIfCustomer, getAloApiAuthHeaders, heapTrack } from 'src/scripts/utils/helpers';
import { InitialUrlSearchParams } from '../../../utils/environment';
import { CustomerData, HeapTrackEventsType } from '../types';
import { WishListTypes } from './wishlist-types';
import { WishlistGA4ProductData, addItemToWishlist } from './wishlistState';
import { changeItemQuantity } from '../../../utils/cart';
import { ALO_API_HOST } from '../../../utils/constants';
import { openSignInModal } from '../ui-components/SignInModal/utils';

const updateWishlist = async (method: 'POST' | 'DELETE', productId: string) => {
  const headers = getAloApiAuthHeaders();
  return await fetch(`${ALO_API_HOST}/v1/wishlist/lists/default/items${method === 'DELETE' ? '/' + productId : ''}`, {
    method,
    headers,
    body: method === 'POST' ? `{"product_gid": ${productId}}` : '',
  });
};

export const addToWishlistCall = async (
  productId: string,
  heapEventProperties?: HeapTrackEventsType['heapEventProperties']
) => {
  const response = await updateWishlist('POST', productId);

  if (response.status === 200 && response.ok) {
    if (heapEventProperties) {
      heapTrack('Web - Wishlist - Add', heapEventProperties);
    }
  }
  return { status: response.status, ok: response.ok, alreadyAdded: response.status === 409 };
};

export const updateAccount = async (customer: CustomerData) => {
  const headers = getAloApiAuthHeaders();
  const method = 'PUT';
  const response = await fetch(`${ALO_API_HOST}/v1/account`, {
    method,
    headers,
    body: JSON.stringify(customer),
  });
  return { status: response.status, ok: response.ok, alreadyAdded: response.status === 409 };
};

export const removeFromWishlistCall = async (
  productId: string,
  heapEventProperties?: HeapTrackEventsType['heapEventProperties']
) => {
  const response = await updateWishlist('DELETE', productId);

  if (response.status === 200 && response.ok) {
    if (heapEventProperties) {
      heapTrack('Web - Wishlist - Remove', heapEventProperties);
    }
  }
  return { status: response.status, ok: response.ok };
};
export const getProductIdsFromWishlistData = (data: WishListTypes[]) => {
  return data.map((node) => node.product_gid);
};

export const addItemToWishlistFromURLparam = async (
  heapEventProperties: HeapTrackEventsType['heapEventProperties']
) => {
  const actionSource = InitialUrlSearchParams?.get('addToWishlistSource');
  const productAddToWishlistKey = InitialUrlSearchParams?.get('addToWishlistProductKey');
  const productDataSessionStorage = parseSessionStorageItem('wishlist_product_data');
  const productIdToAddOnLoad = productDataSessionStorage?.id;
  if (productIdToAddOnLoad && checkIfCustomer()) {
    if (actionSource?.toLowerCase() === 'cart' && productAddToWishlistKey) {
      changeItemQuantity(productAddToWishlistKey, 0);
    }
    heapEventProperties.productId = productIdToAddOnLoad;
    heapEventProperties.isSignedIn = true;
    return await addItemToWishlist(productDataSessionStorage, heapEventProperties);
  }
};

const parseSessionStorageItem = (key: string) => {
  const rawData = window.sessionStorage.getItem(key);
  return rawData !== null ? JSON.parse(rawData) : null;
};

export const addItemToWishlistUrl = (
  addToWishlistProductId?: string,
  addToWishlistSource?: string,
  addToWishlistProductKey?: string
) => {
  if (!addToWishlistProductId) return;
  const params = new URLSearchParams(window.location.search);
  if (addToWishlistProductId) params.set('addToWishlist', addToWishlistProductId);
  if (addToWishlistSource) params.set('addToWishlistSource', addToWishlistSource);
  if (addToWishlistProductKey) params.set('addToWishlistProductKey', addToWishlistProductKey);
  const paramsString = params.toString();
  const symbol = paramsString.length > 1 ? '?' : '';
  if (window.location.pathname.match(/\/account\/login/)) {
    return '/account' + symbol + paramsString;
  }
  return window.location.pathname + symbol + paramsString;
};

export const promptAuthAndWishlistFromURL = (
  addToWishlistSource: string,
  wishlistProductData: WishlistGA4ProductData
) => {
  const returnUrl = addItemToWishlistUrl(wishlistProductData.id, addToWishlistSource, wishlistProductData.key);
  if (wishlistProductData) {
    window.sessionStorage.setItem('wishlist_product_data', JSON.stringify(wishlistProductData));
  }
  openSignInModal({ returnUrl });
};
